import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import { fetchData } from "src/services/dashboard.service";

export const doFetchData = createAsyncThunk(
  "dashboard/detchData",
  async (_) => {
    try {
      const response: any = await fetchData();
      return response.data;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch data";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);
